import type { AxiosInstance } from 'axios';

import type { BaseParameterTypes } from '../baseParams';

import type { BaseParameter, IWellDirectoryService, WellDto, WellIndexType, WellLog } from './IWellDirectoryService';

export class WellDirectoryService implements IWellDirectoryService {
  baseURL: string;

  constructor(
    private axios: AxiosInstance,
    baseURL: string,
  ) {
    this.baseURL = baseURL;
    this.getWell = this.getWell.bind(this);
  }

  getWell(wellId: number, abortController?: AbortController) {
    return this.axios
      .get<WellDto>(`${this.baseURL}/wells/${wellId}`, {
        signal: abortController?.signal,
      })
      .then(({ data }) => data);
  }

  getLogs(wellId: number, wellboreId: number, index?: WellIndexType, abortController?: AbortController) {
    return this.axios
      .get<WellLog[]>(`${this.baseURL}/wells/${wellId}/wellbores/${wellboreId}/logs`, {
        params: { index },
        signal: abortController?.signal,
      })
      .then(({ data }) => data)
      .then((data) =>
        data.map((wellLog) => ({
          ...wellLog,
          runNumber: wellLog.runNumber ?? [],
          curves: wellLog.curves ?? [],
        })),
      );
  }

  getLogById(wellId: number, wellboreId: number, logId: number, abortController?: AbortController) {
    return this.axios
      .get<WellLog>(`${this.baseURL}/wells/${wellId}/wellbores/${wellboreId}/logs/${logId}`, {
        signal: abortController?.signal,
      })
      .then(({ data }) => ({
        ...data,
        runNumber: data.runNumber ?? [],
        curves: data.curves ?? [],
      }));
  }

  getBaseParameters(
    wellboreId: number,
    index: WellIndexType,
    parameters?: BaseParameterTypes[],
    abortController?: AbortController,
  ) {
    return this.axios
      .get<BaseParameter[]>(`${this.baseURL}/baseParameters/${wellboreId}`, {
        params: { logType: index, parameters, autofill: true },
        signal: abortController?.signal,
      })
      .then(({ data }) => data);
  }
}
